/** Site shell copy (nav, auth, detail titles). */
export const siteCoreSv = {
    title: 'Finance Lab App',
    nav: {
        menuSection: 'Meny',
        overview: 'Överblick',
        issues: 'Emissioner',
        warrants: 'Teckningsoptioner',
        convertibles: 'Konvertibler',
        companies: 'Bolag',
        advisors: 'Rådgivare',
        statistics: 'Statistik',
        news: 'Nyheter',
        calendar: 'Kalender',
        reports: 'Rapporter',
        settingsSection: 'Inställningar',
        support: 'Support',
        contact: 'Kontakta oss',
        help: 'Hjälp',
        feedback: 'Feedback',
        adminSection: 'Admin',
        adminDashboard: 'Dashboard',
        adminCustomers: 'Kunder',
        adminUsers: 'Användare',
        adminPRInput: 'PM Indata',
        adminPMCompany: 'PM Bolag',
        adminDelistings: 'Avnoteringar',
        adminIssues: 'Emissioner',
        adminIssuesReview: 'Avstämning',
        adminIssuesNew: 'Ny Emission',
        adminCompanies: 'Bolag',
        adminCompaniesNew: 'Nytt Bolag',
        adminWarrants: 'Teckningsoptioner',
        adminWarrantsNew: 'Ny Teckningsoption',
        adminConvertibles: 'Konvertibler',
        adminConvertiblesNew: 'Ny Konvertibel',
        adminInvestors: 'Investerare',
        adminKeywordFilter: 'Keyword Filter',
        language: 'Språk',
        watchList: 'Bevakningslista',
        notes: 'Anteckningar',
        searchPlaceholder: 'Sök bolag, emissioner, TO, investerare...',
    },
    auth: {
        loginPrompt: 'Logga in för att fortsätta',
        login: 'Logga in',
        logout: 'Logga ut',
        changePassword: 'Ändra lösenord',
        email: 'E-postadress',
        password: 'Lösenord',
        rememberMe: 'Kom ihåg mig',
        forgotPassword: 'Glömt lösenord?',
    },
    convertibles: {
        previous: 'Genomförda',
        current: 'Pågående',
        future: 'Kommande',
        detailsTitle: 'Konvertibel {{name}}',
    },
    instruments: {
        bankruptcy: 'Konkurs',
        liquidation: 'Likvidation',
        merger: 'Fusion',
        acquisition: 'Uppköp',
        changed_marketplace: 'Byte av marknadsplats',
        voluntary_delisting: 'Frivillig avnotering',
        lack_of_compliance: 'Ej uppfyllda noteringskrav',
        redemption: 'Inlösen',
    },
    issues: {
        previous: 'Genomförda',
        current: 'Pågående',
        future: 'Kommande',
        detailsTitle: 'Emission {{name}}',
    },
    warrants: {
        detailsTitle: 'Teckningsoption {{name}}',
    },
    companies: {
        detailsTitle: 'Bolag: {{name}}',
    },
    advisors: {
        detailsTitle: 'Rådgivare: {{name}}',
    },
    statistics: {
        title: 'Statistik',
    },
}
